import React, { PureComponent } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { string, object } from 'prop-types';

class OfferStatsTableItem extends PureComponent {
  static propTypes = {
    period: string.isRequired,
    cr: object.isRequired,
    epc: object.isRequired,
  };

  render() {
    const { period, cr, epc } = this.props;
    return (
      <tr>
        <td className="offer-stats-table-period">
          <FormattedMessage id={`offer.conversions.period.${period}`} defaultMessage={period} />
        </td>
        <td>
          <span
            className={cn('stat-value', {
              up: cr.status === 'up',
              down: cr.status === 'down',
            })}
          >
            {cr.value}
          </span>
        </td>
        <td>
          <span
            className={cn('stat-value', {
              up: epc.status === 'up',
              down: epc.status === 'down',
            })}
          >
            {epc.value}
          </span>
        </td>
      </tr>
    );
  }
}

export default OfferStatsTableItem;
